import { contactManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher];

const contactManagementRouteMetadata: IRouteMetadataObj<
  typeof contactManagementRoutesObj
> = {
  list: {
    title: "contactManagement.index.title",
    description: "contactManagement.index.description",
    lazy: () => import("@/pages/contactManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "QuestionAnswerLine",
    breadcrumbs: [],
    permission,
  },
};

export const contactManagementRoutes = createRoute<
  typeof contactManagementRoutesObj
>(contactManagementRoutesObj, contactManagementRouteMetadata);
